<template>
  <div>
    <section class="section">
      <div class="container">

        
        <div class="columns is-centered">
          <div class="column is-8-desktop is-10">
            <h1 class="title">Your Walls Of Love</h1>
            <div v-bind:class="{'is-hidden': !isLoading}" class="is-active loader-wrapper">
                <div class="loader is-loading"></div>
            </div>
            <div>
              <p class="has-text-centered mb-5">
                <button class="button is-primary" @click.prevent="createWol"
                        :disabled="!createBtnEnabled"
                        v-bind:class="{ 'is-loading': creating }">Create Wall of love</button>
                        <br>
                <span
                  v-if="!createBtnEnabled && !account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!createBtnEnabled && !account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
                <span
                  v-if="!createBtnEnabled && account.has_pro_features"
                  class="tag is-warning"
                  >BIZ</span
                >
                <router-link
                  v-if="!createBtnEnabled && account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </p>
            </div>

            <div v-if="!isLoading && wols.length ==0" class="has-text-centered">
              No Wall of Loves found.
            </div>
            <div v-for="(w, index) in wols" v-bind:key="index" class="card mt-6 is-dark">
                <header class="card-header">
    <p class="card-header-title">
      <router-link
                  :to="{ name: 'UserWallOfLoveEdit', params: { wolId: w.id  }}"
                >{{w.name}}</router-link> 
    </p>
                </header>

  <footer class="card-footer">
                        <router-link
                      class="card-footer-item"
                      :to="{ name: 'UserWallOfLoveEdit', params: { wolId: w.id  }}"
                      title="Edit Details"
                    >
                      <b-icon icon="eye" size="is-small"/>
                    </router-link>
  </footer>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import atomic from "atomicjs";

import { mapState } from 'vuex'
import {trackEvent}  from "../lib/flevents"
export default {
  name: "Dashboard",
  components: {},
  data: function () {
    return {
      wols: [],
      isLoading:false,
      createBtnEnabled: false,
      creating: false,
    };
  },
  mounted: function () {
    if (!this.user.isLoggedIn) {
      this.$router.push("/login");
      return
    }
    if (this.userLoaded === true) {
      this.load();
    }
    trackEvent(this.$store.state.user.id, "wol-list-view")
  },
  computed: {
    subscribed() {
      return this.account.subscribed
    },
    ...mapState([
      "user", "account", "userLoaded"
    ])
  },
  watch: {
    userLoaded: function (val) {
      if (val === true) {
        console.log("user loaded")
        this.load();
      }
    }
  },
  methods: {
    createWol: async function() {
      var self = this;

      var url = self.apiHost + "walloflove"

      this.$store.dispatch('getAPIToken')
        .then((token) => {
          self.creating = true;

          atomic(url, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
            data: {
              name: "love " + (self.wols.length + 1),
              account_id: self.account.id
            }
          })
            .then(function (response) {
              self.$router.push({
                name: "UserWallOfLoveEdit",
                params: { wolId: response.data.id }
              });
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              self.creating = false;
              let msg = `Oops! Something went wrong but it wasn't you. It was us and the team was already notified. Please try again later.`
              self.$buefy.toast.open({
                duration: 5000,
                message: msg,
                type: 'is-danger'
              })
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
    load: async function () {
      var self = this;

      var url = self.apiHost + `account/${this.account.id}/wallofloves`

      this.$store.dispatch('getAPIToken')
        .then((token) => {
          self.isLoading = true;
          console.log("load wols", new Date())
          atomic(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
          })
            .then(function (response) {
              var wols = response.data;
              self.wols = wols;
              self.isLoading = false;

              self.createBtnEnabled = self.wols.length < 1 || self.account.has_biz_features || (self.account.has_pro_features && self.wols.length < 3) 
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              self.isLoading = false;
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
  },
};
</script>

<style scoped>


</style>